import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-889edf9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "teams-filter-top" }
const _hoisted_2 = {
  key: 1,
  class: "navigation-text filter"
}
const _hoisted_3 = { class: "teams-filter-middle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_5 = { class: "filter-set-container" }
const _hoisted_6 = {
  ref: "filterOptions",
  class: "filter-set"
}
const _hoisted_7 = { class: "filter-set-options" }
const _hoisted_8 = { class: "filter-set-container" }
const _hoisted_9 = {
  ref: "timeFilterOptions",
  class: "filter-set"
}
const _hoisted_10 = { class: "filter-set-options" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "divider" }, null, -1))
const _hoisted_12 = { class: "teams-filter-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_PillButton = _resolveComponent("PillButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "teams-filter-container",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('filterLostFocus', false)), ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Typography, {
        component: "span",
        class: "back navigation-text",
        onClick: _ctx.backAction
      }, {
        default: _withCtx(() => [
          (_ctx.backLabel)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_FontAwesomeIcon, {
                  class: "chevron-left",
                  size: "lg",
                  icon: _ctx.faChevronLeft
                }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(_ctx.backLabel), 1)
              ], 64))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_Transition, {
        name: "title",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_Typography, {
            key: _ctx.title,
            component: "span",
            class: "title-text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ], undefined, true),
            _: 1
          }))
        ], undefined, true),
        _: 1
      }),
      (_ctx.hasNetworkConnection)
        ? (_openBlock(), _createBlock(_component_Typography, {
            key: 0,
            component: "span",
            class: "navigation-text filter",
            onClick: _ctx.toggleFilterVisibility
          }, {
            default: _withCtx(() => [
              _createTextVNode(" FILTERS ")
            ], undefined, true),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_2))
    ]),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Typography, {
                component: "div",
                class: "navigation-text filter-set-label"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" View " + _toDisplayString(_ctx.tenant) + " By ", 1)
                ], undefined, true),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions, (option, index) => {
                    return (_openBlock(), _createBlock(_component_PillButton, {
                      key: index,
                      label: 
                                        option.groupName ??
                                        option.fieldMapping ??
                                        ''
                                    ,
                      disabled: _ctx.shouldDisableOption(option),
                      class: _normalizeClass(["filter-button", 
                                        _ctx.filterIsSelected(option)
                                            ? 'selected'
                                            : ''
                                    ]),
                      onClick: ($event: any) => (
                                        _ctx.toggleTeamFilterSelected(option, false)
                                    )
                    }, null, 8, ["label", "disabled", "class", "onClick"]))
                  }), 128))
                ])
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Typography, {
                component: "div",
                class: "navigation-text filter-set-label"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Time Filter ")
                ], undefined, true),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeFilterOptions, (option, index) => {
                    return (_openBlock(), _createBlock(_component_PillButton, {
                      key: index,
                      label: option.label ?? '',
                      class: _normalizeClass(["filter-button", 
                                        _ctx.timeFilterIsSelected(option)
                                            ? 'selected'
                                            : ''
                                    ]),
                      onClick: ($event: any) => (_ctx.toggleTimeFilterSelected(option))
                    }, null, 8, ["label", "class", "onClick"]))
                  }), 128))
                ])
              ], 512)
            ])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Typography, {
              component: "span",
              class: "navigation-text",
              onClick: _ctx.resetFilters
            }, {
              default: _withCtx(() => [
                _createTextVNode(" RESET FILTERS ")
              ], undefined, true),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 512), [
          [_vShow, _ctx.showFilters]
        ])
      ], undefined, true),
      _: 1
    })
  ]))
}